import { Component, OnDestroy, OnInit } from '@angular/core';
import { PayService } from '../service/pay.service';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserSessionService } from '../user-session.service';
import { TranslateService } from '@ngx-translate/core';
import { ConnectedUser } from '../shared/connected-user';





function passwordMatchValidator(g: FormGroup) {
  return g.get('password').value === g.get('confirmPassword').value
    ? null : { 'mismatch': true };
}



@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  standalone: false
})
//AfterViewInit
export class ProfileComponent implements OnInit, OnDestroy {

  email: string;
  isedit: boolean = false;
  firstname: any;
  lastname: any;
  userid: any;
  telephone: any;

  questionResponse: FormGroup;
  userForm: FormGroup;
  isSecure: boolean = false;
  passwordForm: FormGroup;
  validation: boolean;
  letterchange: boolean;
  capitalchange: boolean;
  numberchange: boolean;
  lengthchange: boolean;
  symbolechange: boolean;
  iscode: boolean;
  isupdate: boolean;
  samecode: boolean;
  loader: boolean = false;
  question: any;
  reponse: any;
  secretpin: any;
  contraintpin: any;
  secure = false;
  secretQuestion: string | null = null;
  resetPinsForm!: FormGroup;
  isverify: boolean;
  showssuccess: boolean;
  answerValid = false;
  message: any;
  selectedLanguage = 'fr';
  user: ConnectedUser | null = null;
  // Forgot PIN state
  forgotInitForm!: FormGroup;
  forgotConfirmForm!: FormGroup;
  forgotStep: 'init' | 'confirm' = 'init';
  forgotMessage: string | null = null;
  forgotError: string | null = null;
  forgotLoading = false;
  forgotSuccess = false;
  otpCountdown = 0;
  resendCooldown = 0;
  private otpTimerId: any;
  private resendTimerId: any;
  constructor(private userService: PayService, private userSessionService: UserSessionService, private router: Router, private translate: TranslateService) { }


  ngOnInit(): void {
    this.user = this.userSessionService.getUser();

    console.log("**************************** Profile user *******************************", this.user);

    if (!this.user) {
      // Option 1: attendre un micro-moment puis re-essayer et init
      setTimeout(() => {
        this.user = this.userSessionService.getUser();
        if (this.user) {
          this.initAfterUserLoaded();
        }
      }, 0);
      return;
    }

    this.initAfterUserLoaded();
  }

  ngOnDestroy(): void {
    this.clearTimers();
  }


  private initAfterUserLoaded(): void {
    // Ici user est forcément non-null
    console.log("Username:", this.user!.username);

    this.userService.getSecurityStatus(this.user!.username).subscribe(status => {
      this.secure = status.secure;
      this.secretQuestion = status.secretQuestion ?? null;
    });
    console.log("***************************** Profile user after load *******************************", this.user!.lang);
    this.selectedLanguage = this.user!.lang || localStorage.getItem('lang') || 'fr';
    this.translate.use(this.selectedLanguage);
    this.initquestionResponse();
    this.initUserForm();
    this.initPasswordForm();
    this.initForgotForms();
  }

  initUserForm() {
    this.userForm = new FormGroup({
      firstName: new FormControl('', [Validators.required, Validators.minLength(3)]),
      lastName: new FormControl('', [Validators.required, Validators.minLength(3)]),
      email: new FormControl('', [Validators.required, Validators.pattern("[^ @]*@[^ @]*[.][^ @]{2,}")]),
      phone: new FormControl('', [Validators.required, Validators.pattern("[1-9][0-9]*"), Validators.pattern('(^(65)[0-9]{1}[0-9]{6}|^(69|66|67|64)[0-9]{7})$')]),
    })
  }

  initPasswordForm() {
    this.passwordForm = new FormGroup({
      code: new FormControl("", [Validators.required, Validators.pattern('^[0-9]{6}$')]),
      password: new FormControl('', [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}')]),
      confirmPassword: new FormControl('', [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}')]),
    }, passwordMatchValidator)
  }

  initForgotForms() {
    const usernamePrefill = this.user?.username || '';
    this.forgotInitForm = new FormGroup({
      usernameOrEmail: new FormControl(usernamePrefill, [Validators.required])
    });

    this.forgotConfirmForm = new FormGroup({
      usernameOrEmail: new FormControl(usernamePrefill, [Validators.required]),
      otp: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{6}$')]),
      newSecretPin: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{6}$')])
    });
  }

  initquestionResponse() {
    this.questionResponse = new FormGroup(
      {
        question: new FormControl('', [Validators.required]),
        reponse: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(16)]),
        secretpin: new FormControl("", [Validators.required, Validators.pattern('^[0-9]{6}$')]),
        contraintpin: new FormControl("", [Validators.required, Validators.pattern('^[0-9]{6}$')])
      })

    this.resetPinsForm = new FormGroup({
      answer: new FormControl('', [Validators.required, Validators.minLength(4)]),
      oldSecretPin: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{6}$')]),
      newSecretPin: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{6}$')]),
    });

  }
  /*initUtilisateurInformations() {
    this.userService.getUtilisateursInformations(this.email).subscribe(data => {

      this.question = data['secretQuestion'];
      this.reponse = data['secretAnswer'];
      this.secretpin = data['secretpin'];
      this.contraintpin = data['contraintpin'];

      console.log(data);
    })
  }*/
  setupSecurity() {
    if (this.questionResponse.invalid) return;

    const v = this.questionResponse.value;

    this.userService.setupSecurity({
      secretQuestion: v.question,
      secretAnswer: v.reponse,
      secretPin: v.secretpin,
      contraintPin: v.contraintpin,
      username: this.userSessionService.getUser().username
    }).subscribe(() => {
      this.userService.getSecurityStatus(this.userSessionService.getUser().username).subscribe(status => {
        console.log("*********************************************************", status);
        this.secure = status.secure;
        this.secretQuestion = status.secretQuestion ?? null;
      });
    });
  }

  // -------- Forgot PIN (email OTP) ----------
  startResendCooldown(seconds: number) {
    this.resendCooldown = seconds;
    if (this.resendTimerId) clearInterval(this.resendTimerId);
    this.resendTimerId = setInterval(() => {
      this.resendCooldown -= 1;
      if (this.resendCooldown <= 0) {
        clearInterval(this.resendTimerId);
        this.resendTimerId = null;
      }
    }, 1000);
  }

  startOtpCountdown(seconds: number) {
    this.otpCountdown = seconds;
    if (this.otpTimerId) clearInterval(this.otpTimerId);
    this.otpTimerId = setInterval(() => {
      this.otpCountdown -= 1;
      if (this.otpCountdown <= 0) {
        clearInterval(this.otpTimerId);
        this.otpTimerId = null;
      }
    }, 1000);
  }

  clearTimers() {
    if (this.otpTimerId) clearInterval(this.otpTimerId);
    if (this.resendTimerId) clearInterval(this.resendTimerId);
  }

  submitForgotInit() {
    if (this.forgotInitForm.invalid || this.forgotLoading) return;
    this.forgotLoading = true;
    this.forgotMessage = null;
    this.forgotError = null;

    const payload = this.forgotInitForm.value;
    this.userService.securityPinForgotInit(payload).subscribe({
      next: () => {
        this.forgotLoading = false;
        this.forgotStep = 'confirm';
        this.forgotMessage = 'Si le compte existe, un code a été envoyé.';
        this.forgotSuccess = true;
        this.forgotConfirmForm.get('usernameOrEmail')?.setValue(payload.usernameOrEmail);
        this.startOtpCountdown(10 * 60);
        this.startResendCooldown(60);
      },
      error: () => {
        // Même message pour éviter l’énumération
        this.forgotLoading = false;
        this.forgotStep = 'confirm';
        this.forgotMessage = 'Si le compte existe, un code a été envoyé.';
        this.forgotSuccess = true;
        this.startOtpCountdown(10 * 60);
        this.startResendCooldown(60);
      }
    });
  }

  resendForgotInit() {
    if (this.resendCooldown > 0) return;
    this.submitForgotInit();
  }

  submitForgotConfirm() {
    if (this.forgotConfirmForm.invalid || this.forgotLoading) return;
    this.forgotLoading = true;
    this.forgotMessage = null;
    this.forgotError = null;

    const payload = this.forgotConfirmForm.value;
    this.userService.securityPinForgotConfirm(payload).subscribe({
      next: () => {
        this.forgotLoading = false;
        this.forgotSuccess = true;
        this.forgotError = null;
        this.forgotMessage = 'Votre code secret a été réinitialisé.';
        this.forgotStep = 'init';
        this.forgotConfirmForm.reset({ usernameOrEmail: this.user?.username || '' });
        this.startOtpCountdown(0);
      },
      error: () => {
        this.forgotLoading = false;
        this.forgotSuccess = false;
        this.forgotError = 'Code invalide ou expiré. Merci de réessayer.';
      }
    });
  }

  updateSecurityCode() {
    if (this.resetPinsForm.invalid) return;
    const v = this.resetPinsForm.value;
    console.log(v);
    this.userService.updateSecurityCode({
      answer: v.answer,
      oldSecretPin: v.oldSecretPin,
      newSecretPin: v.newSecretPin,
      username: this.userSessionService.getUser().username
    }).subscribe(() => {
      this.showssuccess = true;
      setTimeout(() => {
        this.showssuccess = false;

      }, 3000);
    }, err => {
      // afficher message "Réponse incorrecte"
    });
  }

  updateUserInformation(formdata) {
    this.userService.changeUserinformation(this.userid, formdata).subscribe(data => {
      if (data == 0) {
        this.isedit = false;
        this.userService.getUtilisateursInformations(formdata.email).subscribe(data => {


        })
      }
    })
  }


  onAnswerBlur() {
    const answer = this.resetPinsForm.get('answer')?.value;
    if (!answer) return;

    this.verifySecretAnswer(answer);
  }
  verifySecretAnswer(answer: string) {
    this.userService.verifySecretAnswer({
      answer,
      username: this.userSessionService.getUser().username
    }).subscribe({
      next: (data) => {
        if (data === 0) {
          // mauvaise réponse
          this.answerValid = false;
          this.isverify = true;

          // efface le message après 4s
          setTimeout(() => {
            this.isverify = false;
          }, 4000);

        } else {
          // bonne réponse
          this.answerValid = true;
          this.isverify = false;
        }
      },
      error: () => {
        // en cas d'erreur serveur, mets en faux aussi
        this.answerValid = false;
        this.isverify = true;
      }
    });
  }

  /*verifySecretAnswer(answer: string) {
    this.userService.verifySecretAnswer({ answer, username: this.userSessionService.getUser().username }).subscribe(data => {
      if (data == 0) {
        this.isverify = true;
        setTimeout(() => {
          this.isverify = false;
        }, 4000);
      }
    })
  }*/

  editer() {
    this.userForm.get('email').setValue(this.email);
    this.userForm.get('firstName').setValue(this.userSessionService.getUser().firstname);
    this.userForm.get('lastName').setValue(this.userSessionService.getUser().lastname);
    this.userForm.get('phone').setValue(this.userSessionService.getUser().phone)
    this.isedit = true;
  }
  stop() {
    this.isedit = false;
  }

  sendsecretquestion(formdata) {

    if (Number(this.questionResponse.get('secretpin').value) == Number(this.questionResponse.get('contraintpin').value)) {
      this.samecode = true
      setTimeout(() => {
        this.samecode = false;
      }, 3000);

    }
    else {

      this.userService.addsecretQuestion(this.userid, formdata).subscribe(data => {
        if (data == 0) {
          this.loader = true;
          setTimeout(() => {
            this.loader = false;
            window.location.reload();
          }, 3000);
        }
        else {

        }
      })
    }

  }



  updateUserPassword() {
    const val = this.passwordForm.value;

    this.userService.updateUserPassword({
      code: val.code,
      password: val.password,
      username: this.userSessionService.getUser().username
    }).subscribe({
      next: (res) => {
        const key = String(res.code ?? 'message.password.updated');
        this.isupdate = true;
        this.translate.get(key, {}).subscribe(msg => {
          this.message = msg;
          setTimeout(() => {
            this.isupdate = false;
          }, 3000);
        });
      },
      error: (err) => {
        // this.message = 'Erreur technique';
      }
    });
  }

  changeLanguage() {
    const lang = this.selectedLanguage || 'fr';

    // 1) appliquer immédiatement
    this.translate.use(lang);
    localStorage.setItem('lang', lang);

    // 2) envoyer en DB si connecté
    const user = this.userSessionService.getUser();
    if (!user?.username) return;

    this.userService.updateLanguage(lang).subscribe({
      next: (res) => {
        // 3) mettre à jour session user local
        user.lang = lang;
        this.userSessionService.getUser().lang = lang;

        // Optionnel: message i18n via code
        // this.translate.get(res.code).subscribe(m => this.message = m);
        this.message = 'OK';
      },
      error: (err) => {
        // rollback optionnel si tu veux
        // (moi je rollback pas, je garde l’UI et je retenterai plus tard)
        this.message = 'Erreur lors de la sauvegarde';
      }
    });
  }


  sendit1(val) {
    var lowerCaseLetters = /[a-z]|[A-Z]/g;
    if (val.match(lowerCaseLetters)) {
      this.questionResponse.get('secretpin').setValue("");
    } else {

    }
  }

  sendit2(val) {
    var lowerCaseLetters = /[a-z]|[A-Z]/g;
    if (val.match(lowerCaseLetters)) {
      this.questionResponse.get('contraintpin').setValue("");
    } else {

    }
  }
  sendit3(val) {
    let uppercase: String = val;
    var upperCaseLetters = /[A-Z]/g;
    if (val.match(upperCaseLetters)) {
      this.questionResponse.get('reponse').setValue(uppercase.toLocaleLowerCase());
    } else {

    }
  }
  showvalidationpart() {
    this.validation = true;
  }
  hidevalidationpart() {
    this.validation = false;

  }
  validateValue(textValue) {
    var lowerCaseLetters = /[a-z]/g;
    if (this.passwordForm.get('password').value.match(lowerCaseLetters)) {
      this.letterchange = true;
    } else {
      this.letterchange = false;
    }

    var upperCaseLetters = /[A-Z]/g;
    if (this.passwordForm.get('password').value.match(upperCaseLetters)) {
      this.capitalchange = true;
    } else {
      this.capitalchange = false;
    }

    // Validate numbers
    var numbers = /[0-9]/g;
    if (this.passwordForm.get('password').value.match(numbers)) {
      this.numberchange = true;

    } else {
      this.numberchange = false;
    }

    // Validate length
    if (this.passwordForm.get('password').value.length >= 8 && this.passwordForm.get('password').value.length < 17) {
      this.lengthchange = true
    } else {
      this.lengthchange = false
    }
    var symbole = /[$@$!%*?&]/g
    if (this.passwordForm.get('password').value.match(symbole)) {
      this.symbolechange = true;

    } else {
      this.symbolechange = false;
    }

  }

  get password() { return this.passwordForm.get('password'); }
  get confirmPassword() { return this.passwordForm.get('confirmPassword'); }

}
